module.exports = "/images/vendor/flag-icon-css/flags/1x1/bg.svg?7163fe7683bf09611884f33ebf512d6a";